import { Component, Input } from '@angular/core';
import { Insider } from '@shared/models/be-experience.model';

@Component({
  selector: 'ess-experience-insiders',
  templateUrl: './experience-insiders.component.html',
  styleUrls: ['./experience-insiders.component.scss'],
  standalone: false,
})
export class ExperienceInsidersComponent {
  @Input() insiders: Insider[] = [];
}
